import { render } from "./Kitchen.vue?vue&type=template&id=0e1be676"
import script from "./Kitchen.vue?vue&type=script&lang=js"
export * from "./Kitchen.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__